import { Authentication } from '@leedpulse-monorepo/classes';
import { ISubscription } from '@leedpulse-monorepo/interfaces';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import Subscription from '../../models/Subscription';

interface GetCompanySubscriptionsPayload {
  company_id: string;
  /** When provided, only these subscription IDs are returned (intersected with the user's access) */
  subscription_ids?: string[];
}

export async function getCompanySubscriptions(
  payload: GetCompanySubscriptionsPayload,
  auth: Authentication,
): Promise<Subscription[]> {
  try {
    if (!payload.company_id) {
      throw new GetCompanySubscriptionsFailure('company_id est requis');
    }

    const body: Record<string, unknown> = { company_id: payload.company_id };
    if (payload.subscription_ids && payload.subscription_ids.length > 0) {
      body.subscription_ids = payload.subscription_ids;
    }

    const response = await HttpClient.post(
      '/company/subscriptions',
      body,
      auth.token,
    );

    const subscriptions: Subscription[] = (response.data as ISubscription[]).map(
      (sub) => Subscription.fromJson(sub)
    );

    return subscriptions;
  } catch (e) {
    console.error('getCompanySubscriptions error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new GetCompanySubscriptionsFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new GetCompanySubscriptionsFailure(e.message);
    }
    return Promise.reject(e);
  }
}

export class GetCompanySubscriptionsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}
